// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_TP_CONTA_BANC = {
  Corrente: 'FIN_TP_CONTA_BANC1',
  InvestimentoAutomatico: 'FIN_TP_CONTA_BANC2',
  CarteiraDeInvestimento: 'FIN_TP_CONTA_BANC3',
  CaixaInterno: 'FIN_TP_CONTA_BANC4',
  ContaGarantia: 'FIN_TP_CONTA_BANC5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_TP_CONTA_BANC1: 1,
    FIN_TP_CONTA_BANC2: 2,
    FIN_TP_CONTA_BANC3: 3,
    FIN_TP_CONTA_BANC4: 4,
    FIN_TP_CONTA_BANC5: 5
  }
}
